import React, { Component } from "react";
import { connect } from "react-redux";
import Dialog from "material-ui/Dialog";
import { Field, FieldArray, reduxForm } from 'redux-form';
import moment from 'moment';
import { saveTarget } from '../../../../../../MastersDataCollection/curriculumLibraries/components/target/actions/targetActions';
import { getSkillAcquisitionTargetListDetails } from '../../components/Target/actions/skillAquisitionTargetActions';
import { MODULE } from './constants/ApiConstants';
import validate from './validate';

import { renderTextField, renderDateField, renderAutoCompleteSingleSelect, renderTextArea, isInteger, normalizeRate } from '../../../../../../../components/reduxFields';
import { CancelButton, SubmitButtonModal, SubmitButtonModalDisabled } from '../../../../../../../components/buttons';
import SmallLoader from '../../../../../../../img/small-loader.gif';
import { checkFieldExistence, clearFieldErrorArray } from '../../../../../../../modules/AppConfig/actions';
import { displayCustomError } from '../../../../../../../actions/utilAction';

class TargetModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: true,
      skillAquisitionTargetId: props.skillAquisitionTargetId,
      skillsAcquisitionProgramId: props.skillsAcquisitionProgramId,
      targetId: props.targetId,
      patientId: props.patientId,
      masterPrograms: this.props.masterPrograms,
      dateOpened: '',
      dateClosed: '',
      dateMastered: '',
      dateMetBaseline: '',
      showTaskAnalysisStep: false,
      showDurationResponseCriteria: false,
      targetName:"",
    };
    this.onDateChange = this.onDateChange.bind(this);
  }

  componentWillMount() {    
    if (this.state.skillAquisitionTargetId) {
      this.props.getSkillAcquisitionTargetListDetails(this.state.skillAquisitionTargetId);
    }
  }

  handleOpen = () => {
    this.setState({ open: true });
  };

  handleClose = () => {
    if (this.state.open) {
      this.props.clearFieldErrorArray();
      this.setState({ open: false });
      this.props.closeDialog();
    }
  };

  componentWillReceiveProps(nextProps) {
    let self = this;
    document.onkeydown = function (evt) {
      evt = evt || window.event;
      if (evt.keyCode === 27) {
        self.handleClose();
      }
    };

    if (((nextProps.dateOpened && nextProps.dateOpened !== this.props.dateOpened) || 
    (nextProps.dateClosed && nextProps.dateClosed !== this.props.dateClosed) || 
    (nextProps.dateMastered && nextProps.dateMastered !== this.props.dateMastered) || 
    (nextProps.dateMetBaseline && nextProps.dateMetBaseline !== this.props.dateMetBaseline)) && this.props.skillAquisitionTargetId > 0){      
      this.setState({
        dateOpened: nextProps.dateOpened,
        dateClosed: nextProps.dateClosed,
        dateMastered: nextProps.dateMastered,
        dateMetBaseline: nextProps.dateMetBaseline,
      });
    }
    if (nextProps.targetTypeName && nextProps.targetTypeName !== this.props.targetTypeName && nextProps.targetTypeName === 'Task Analysis'){  
      this.setState({showTaskAnalysisStep: true, showDurationResponseCriteria: false});      
    }
    if (nextProps.targetTypeName && nextProps.targetTypeName !== this.props.targetTypeName && nextProps.targetTypeName === 'Duration'){  
      this.setState({showTaskAnalysisStep: false, showDurationResponseCriteria: true});      
    }
    
    
  }

  renderLoading() {
    return (
      <div>
        {this.props.loading ? (
          <div className="full_loader top0">
            <div className="small-loader">
              <img src={SmallLoader} alt="" />
            </div>
          </div>
        ) : null}
      </div>
    );
  }

  onSubmitHandler(formProps) {
    if ((this.props.fieldError && this.props.fieldError.length) || (this.props.fieldErrorLoading)) { // Avoid Submit if field error checking
      return null;
    }

    let postData = {
      "id": this.props.targetId || 0,
      "skillAquisitionTargetId": this.props.skillAquisitionTargetId || 0,
      "domainId": this.props.domainId,
      "domainName": '',
      "programId": this.props.programId,
      "skillsAcquisitionProgramId": this.props.skillsAcquisitionProgramId,      
      "programName": " ",
      "targetName": formProps.targetName,
      "goalName": formProps.goalName,
      "generalizatonPlan": formProps.generalizatonPlan,      
      "sd": formProps.sd,
      "targetInstructions": formProps.targetInstructions || '',
      "desiredDailyTrialsId": formProps.desiredDailyTrialsId || null,
      "autoOpenOrderId": null,
      "autoOpen": " ",
      "targetTypeId": formProps.targetTypeId || null,      
      "targetType": " ",
      "responsePercentageId": formProps.responsePercentageId || null,
      "responseCriteria": this.state.showDurationResponseCriteria ? (formProps.responseCriteria || 0.00) : 0.00,
      "consecutiveDaysId": formProps.consecutiveDaysId || null,
      "firstTrialMustBeIndependentId": formProps.firstTrialMustBeIndependentId || null,
      "maintenanceLevelId": formProps.maintenanceLevelId || null,
      // "isActive": formProps.isActive || 0,
      "isActive": this.props.skillAquisitionTargetId > 0 ? this.props.isActive : 1,
      "patientId": parseInt(this.state.patientId),
      "dateOpened": formProps.dateOpened ? moment(formProps.dateOpened).format('YYYY-MM-DD') : null,
      "dateClosed": formProps.dateClosed ? moment(formProps.dateClosed).format('YYYY-MM-DD') : null,
      "dateMastered": formProps.dateMastered ? moment(formProps.dateMastered).format('YYYY-MM-DD') : null,
      "dateMetBaseline": formProps.dateMetBaseline ? moment(formProps.dateMetBaseline).format('YYYY-MM-DD') : null,      
      "masteryTypeId": formProps.masteryTypeId || null,
      "totalRecords": 0
    }

    // ---------------Start Save to taskAnalysisModel in target------------
    
    let listTaskAnalysis = [];
    if (formProps.taskAnalysisModel && formProps.taskAnalysisModel.length) { 
      formProps.taskAnalysisModel.filter((data, i) => {
        if (data.taskName && data.displayOrder) {
          let taskAnalysis = {           
            'taskAnalysisId': data.taskAnalysisId || 0,            
            'skillsAcquisitionTargetId': data.skillsAcquisitionTargetId ? data.skillsAcquisitionTargetId : this.state.skillAquisitionTargetId ? this.state.skillAquisitionTargetId : 0,
            'taskName': data.taskName,          
            'displayOrder': parseInt(data.displayOrder),
          };
          listTaskAnalysis.push(taskAnalysis);
        }
        return listTaskAnalysis;
      });
    }
    postData.dcPatientTargetTaskAnalysisModel = listTaskAnalysis;
    // ---------------End Save to taskAnalysisModel in target------------

    // ---------------Start Save to taskAnalysisModel in master target------------    
    let listTaskAnalysis1 = [];
    if (formProps.taskAnalysisModel && formProps.taskAnalysisModel.length) { 
      formProps.taskAnalysisModel.filter((data, i) => {
        if (data.taskName && data.displayOrder) {
          let taskAnalysis = {           
            'taskAnalysisId': data.taskAnalysisId || 0,            
            'targetId': this.props.targetId || 0, 
            'taskName': data.taskName,          
            'displayOrder': parseInt(data.displayOrder),
          };
          listTaskAnalysis1.push(taskAnalysis);
        }
        return listTaskAnalysis1;
      });
    }
    postData.dcMasterTargetTaskAnalysisModel = listTaskAnalysis1;
    // ---------------End Save to taskAnalysisModel in master target------------


    this.props.clearFieldErrorArray();
    this.props.saveTarget(postData, this.state.patientId, this.props.skillsAcquisitionProgramId);
    this.setState({ open: false });
    this.props.closeDialog();
    // this.props.loadData();
  }

  middleWare = (input,selectedRecord)=>{
    input.onChange(selectedRecord.value);  
   if(input.name === 'targetTypeId')
     {
       if(selectedRecord.label === 'Task Analysis')
       { 
         this.setState({showTaskAnalysisStep: true});        
       }
       else
       {
         this.setState({showTaskAnalysisStep: false});
       }      
   }
       let addColString  =  `${selectedRecord.value},${this.state.skillsAcquisitionProgramId}` 
       let postData = {
       'AdditionalColmnId':addColString, 
       'labelName': "Target Name",
       'tableName':"DCMASTER_TARGETS_TARGETNAME",
       'value': this.state.targetName,
       'colmnName':"TARGETNAME",
       'patientId': this.state.patientId || 0,
       'id': this.state.targetId || 0, 
     };

     this.props.checkFieldExistence(postData);
 }

  checkFieldDataExistence = (input, value, labelName) => {
    this.setState({targetName:value})
    // if (value.length > 0) {
    //   let postData = {
    //     'labelName': labelName,
    //     'tableName': `${MODULE}_${input.target.name}`.toUpperCase(),
    //     'value': value,
    //     'colmnName': input.target.name.toUpperCase(),
    //     'id': this.state.targetId || 0,
    //     'patientId': this.state.patientId || 0,
    //     'AdditionalColmnId':this.props.targetType.id || ''
    //   };
    //   this.props.checkFieldExistence(postData);
    // }
  };

   handleNewRequest = (input, selectedRecord) => {
    input.onChange(selectedRecord.value);
    this.setState({
      targeTypeid : selectedRecord.value,
      targetTypeValue : selectedRecord.label,
    })
    if (input.name === "domainId") {
      let filteredPrograms = this.props.masterPrograms.filter(obj => {
        return obj.domainId === selectedRecord.value
      })
      this.setState({
        masterPrograms: filteredPrograms
      })
    }
    else if(input.name === 'targetTypeId')
    {
      if(selectedRecord.label === 'Task Analysis')
      { 
        this.setState({showTaskAnalysisStep: true, showDurationResponseCriteria: false});        
      }
      else
      {
        if(selectedRecord.label === 'Duration')
        { 
          this.setState({showTaskAnalysisStep: false, showDurationResponseCriteria: true});        
        }
        else {
          this.setState({showTaskAnalysisStep: false, showDurationResponseCriteria: false});
        }
      }      
    }
  };

  onDateChange(input, value) {
    input.onChange(moment(value).format());
    this.setState({ [input.name]: value });
  }

  addTaskRow = () => { };
  removeTaskRow = (i) => { };

  renderTaskAnalysisTemplate = ({ fields }) => {
    this.addTaskRow = (e) => {
      fields.push({});
    };

    this.removeTaskRow = (i, e) => {
      fields.remove(i);
    };

    return (
      <div>
        {fields.map((taskAnalysisModel, i) =>
          <div id="currentDiv" className="row" key={i}>
            <div className="col-sm-7 require">
              <Field
                name={`taskAnalysisModel[${i}].taskName`}
                type="text"
                maxLength="100"
                label="Task Name"
                component={renderTextField}
              />
            </div>
            <div className="col-sm-5 pdl-40 require">
              <Field
                name={`taskAnalysisModel[${i}].displayOrder`}
                type="text"
                maxLength="2"
                label="Display Order"
                component={renderTextField}
                normalize={isInteger}
              />
              {fields.length === i + 1 ?
                <div>
                  {fields.length > 1 ?
                    <button className=" additem removeitem"
                      onClick={this.removeTaskRow.bind(this, i)}
                      title="Remove Step"
                      type="button">
                      <b className="fa fa-minus-square redfont" aria-hidden="true"></b>
                    </button>
                    : ''}
                  <button className="additem" title="Add Step" onClick={(e) => this.addTaskRow()} type="button">
                    <b className="fa fa-plus-square greenfont" aria-hidden="true"></b>
                  </button>
                </div>
                :
                <div>
                  <button className="additem"
                    onClick={this.removeTaskRow.bind(this, i)}
                    title="Remove Step"
                    type="button">
                    <b className="fa fa-minus-square redfont" aria-hidden="true"></b>
                  </button>
                </div>
              }

            </div>
          </div>
        )
        }
      </div>
    );
  };

  render() {
    const { handleSubmit } = this.props;
    let submitButton = this.props.loading ?
      <SubmitButtonModalDisabled label="Loading" /> :
      <SubmitButtonModal label="Save" onSubmit={handleSubmit(this.onSubmitHandler.bind(this))} />;
    const actions = [
      <CancelButton className="mr-15" onTouchTap={this.handleClose} />,
      submitButton,
    ];
    return (
      <Dialog
        className="custom_modal"
        title={
          this.state.skillAquisitionTargetId
            ? "Edit Target"
            : "Add Target"
        }
        modal={false}
        open={this.state.open}
        actions={actions}
        autoScrollBodyContent={true}
      >
        {this.renderLoading()}
        <div className="row">
          <div className="col-sm-12">
            <form
              className="readmin-form custom_form"
              onSubmit={handleSubmit(this.onSubmitHandler.bind(this))}
            >
              <div className="readmin-panel mt-30">
                <div className="panel-body">
                  <h5>Target Information</h5>
                  <div className="row">
                    <div className="col-sm-6 require">
                      <Field
                        name="targetName"
                        type="text"
                        onBlur={(input, value) => this.checkFieldDataExistence(input, value, 'Target Name')}
                        customError={displayCustomError('TARGETNAME', this.props.fieldError)}
                        maxLength="250"
                        label="Target Name"
                        // normalize={isValidNameWithSpace}
                        component={renderTextField}
                      />
                    </div>
                    <div className="col-sm-6">
                      <Field
                        name="goalName"
                        type="text"
                        // onBlur={(input, value) => this.checkFieldDataExistence(input, value, 'Goal Name')}
                        // customError={displayCustomError('GOALNAME', this.props.fieldError)}
                        maxLength="3000"
                        label="Goal Name"
                        // normalize={isValidNameWithSpace}
                        component={renderTextField}
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-sm-6">
                      <Field
                        name="sd"
                        type="text"
                        // onBlur={(input, value) => this.checkFieldDataExistence(input, value, 'SD')}
                        // customError={displayCustomError('SD', this.props.fieldError)}
                        maxLength="250"
                        label="SD"
                        // normalize={isValidNameWithSpace}
                        component={renderTextField}
                      />
                    </div>
                    <div className="col-sm-6 mt-30">
                      <Field
                        autoFocus={true}
                        name="desiredDailyTrialsId"
                        label="Desired Daily Trials"
                        handleNewRequest={this.handleNewRequest}
                        options={this.props.desiredDailyTrials}
                        component={renderAutoCompleteSingleSelect}
                      />
                    </div>
                  </div>
                  <div className="row">
                    {/* <div className="col-sm-6 require mt-30">
                  <Field
                    autoFocus={true}
                    name="autoOpenOrderId"
                    label="Auto-Open Order"
                    handleNewRequest={this.handleNewRequest}
                    options={this.props.autoOpenOrder}
                    component={renderAutoCompleteSingleSelect}
                  />
                </div> */}
                    <div className="col-sm-6 require mt-30">
                      <Field
                        autoFocus={true}
                        name="targetTypeId"
                        label="Target Type"
                        // handleNewRequest={this.handleNewRequest}
                        handleNewRequest = {this.middleWare}
                        options={this.props.targetType}
                        component={renderAutoCompleteSingleSelect}
                      />
                    </div>
                    <div className="col-sm-6 mt-30">
                      <Field
                        autoFocus={true}
                        name="masteryTypeId"
                        label="Mastery Type"
                        handleNewRequest={this.handleNewRequest}
                        options={this.props.masteryType}
                        component={renderAutoCompleteSingleSelect}
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-sm-12">
                        <Field
                          name="generalizatonPlan"
                          type="text"
                          // onBlur={(input, value) => this.checkFieldDataExistence(input, value, 'Goal Name')}
                          // customError={displayCustomError('GeneralizatonPlan', this.props.fieldError)}
                          maxLength="3000"
                          label="Generalizaton Plan"
                          // normalize={isValidNameWithSpace}
                          component={renderTextField}
                        />
                      </div>
                  </div>
                  {this.state.showTaskAnalysisStep ?
                      <FieldArray name="taskAnalysisModel" component={this.renderTaskAnalysisTemplate} />
                  :null}
                  <div className="row">
                    <div className="col-sm-12">
                      <Field
                        name="targetInstructions"
                        type="text"
                        maxLength="4000"
                        label="Target Instructions"
                        // normalize ={isValidNameWithSpace}
                        component={renderTextArea} />
                    </div>
                  </div>
                  {/* <div className="row">
                    <div className="col-sm-6 mt-30">
                      <Field
                        className="mt20 mb0"
                        name="isActive"
                        label="Is Active"
                        component={renderCheckBox}
                      />
                    </div>
                  </div> */}
                </div>
              </div>

              <div className="readmin-panel mt-30">
                <div className="panel-body">
                  <h5>Advanced Options</h5>
                  <div className="row">
                    <div className="col-sm-12 mt-30">
                      <Field name="dateOpened"
                        placeholder="Date Opened"
                        locale="en-US"
                        onDateChange={this.onDateChange}
                        selected={this.state.dateOpened ? this.state.dateOpened : null}
                        // selected={this.state.targetId !== null ? this.props.dateOpened : this.state.dateOpened}
                        openToYearSelection={true}
                        component={renderDateField} />
                    </div>

                    <div className="col-sm-12 mt-30">
                      <Field name="dateMastered"
                        placeholder="Date Mastered"
                        locale="en-US"
                        onDateChange={this.onDateChange}
                        selected={this.state.dateMastered ? this.state.dateMastered : null}
                        openToYearSelection={true}
                        component={renderDateField} />
                    </div>

                    <div className="col-sm-12 mt-30">
                      <Field name="dateClosed"
                        placeholder="Date Closed"
                        locale="en-US"
                        onDateChange={this.onDateChange}
                        selected={this.state.dateClosed ? this.state.dateClosed : null}
                        openToYearSelection={true}
                        component={renderDateField} />
                    </div>

                    <div className="col-sm-12 mt-30">
                      <Field name="dateMetBaseline"
                        placeholder="Met Baseline"
                        locale="en-US"
                        onDateChange={this.onDateChange}
                        selected={this.state.dateMetBaseline ? this.state.dateMetBaseline : null}
                        openToYearSelection={true}
                        component={renderDateField} />
                    </div>
                  </div>
                </div>
              </div>

              <div className="readmin-panel mt-30">
                <div className="panel-body">
                  <h5>Override Mastery Criterion</h5>
                  <div className="row">
                    {this.state.showDurationResponseCriteria ? 
                      <div className="col-sm-6">
                        <Field
                            name="responseCriteria"
                            type="text"
                            // disabled={true}
                            maxLength="8"
                            label="Response Criteria"
                            component={renderTextField}
                            normalize={normalizeRate}
                          />
                      </div>
                    :
                    <div className="col-sm-6 mt-30">
                      <Field
                        autoFocus={true}
                        name="responsePercentageId"
                        label="Response Criteria"
                        handleNewRequest={this.handleNewRequest}
                        options={this.props.responsePercentage}
                        component={renderAutoCompleteSingleSelect}
                      />
                    </div>}
                    <div className="col-sm-6 mt-30">
                      <Field
                        autoFocus={true}
                        name="consecutiveDaysId"
                        label="Consecutive Days"
                        handleNewRequest={this.handleNewRequest}
                        options={this.props.consecutiveDays}
                        component={renderAutoCompleteSingleSelect}
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-sm-6 mt-30">
                      <Field
                        autoFocus={true}
                        name="firstTrialMustBeIndependentId"
                        label="First Trial Must Be Independent"
                        handleNewRequest={this.handleNewRequest}
                        options={this.props.firstTrialMustBeIndependent}
                        component={renderAutoCompleteSingleSelect}
                      />
                      <small className="redfont font12">This field is applicable only for DTT or TA.</small>
                    </div>
                    <div className="col-sm-6 mt-20">

                    </div>
                  </div>
                </div>
              </div>

              <div className="readmin-panel mt-30">
                <div className="panel-body">
                  <h5>Maintenance Level</h5>                 
                  <div className="row">
                    <div className="col-sm-6 mt-30">
                      <Field
                        autoFocus={true}
                        name="maintenanceLevelId"
                        label="Maintenance Level"
                        handleNewRequest={this.handleNewRequest}
                        options={this.props.dcMasterMaintenanceLevels}
                        component={renderAutoCompleteSingleSelect}
                      />
                    </div>
                    <div className="col-sm-6 mt-20">
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </Dialog>
    );
  }
}

TargetModal = reduxForm({
  form: 'TargetModalForm',
  validate,
  enableReinitialize: true,
})(TargetModal);


function mapStateToProps(state, ownProps) {

  let initialValueData = {
    taskAnalysisModel: [{}],
    //isActive: true,
  };
  if (ownProps.skillAquisitionTargetId && state.skillAcquisitionTarget.skillAcquisitionTargetDetail) {
    //initialValueData = state.skillAcquisitionTarget.skillAcquisitionTargetDetail.data || null;

    let targetDetailData = state.skillAcquisitionTarget.skillAcquisitionTargetDetail.data || null;
    let taskAnalysisModel = [];
    if (targetDetailData.dcPatientTargetTaskAnalysisModel && targetDetailData.dcPatientTargetTaskAnalysisModel.length) {
      targetDetailData.dcPatientTargetTaskAnalysisModel.filter((data, i) => {
        taskAnalysisModel.push({
          'taskAnalysisId': data.taskAnalysisId,
          'skillsAcquisitionTargetId': data.skillsAcquisitionTargetId,
          'taskName': data.taskName,          
          'displayOrder': data.displayOrder,
        });
        return taskAnalysisModel;
      });
    } else {
      taskAnalysisModel = [{}];
    }

    initialValueData = {
      ...targetDetailData,   
      taskAnalysisModel: taskAnalysisModel,
      id: targetDetailData.id,
    };
  }

  return {
    loading: state.skillAcquisitionTarget.loading,
    fieldError: state.appConfig.fieldError,
    fieldErrorLoading: state.appConfig.fieldErrorLoading,
    initialValues: initialValueData,
    dateOpened: state.skillAcquisitionTarget.skillAcquisitionTargetDetail != null ? state.skillAcquisitionTarget.skillAcquisitionTargetDetail.data.dateOpened ? moment(state.skillAcquisitionTarget.skillAcquisitionTargetDetail.data.dateOpened) : '' : '',
    dateMastered: state.skillAcquisitionTarget.skillAcquisitionTargetDetail != null ? state.skillAcquisitionTarget.skillAcquisitionTargetDetail.data.dateMastered ? moment(state.skillAcquisitionTarget.skillAcquisitionTargetDetail.data.dateMastered) : '' : '',
    dateClosed: state.skillAcquisitionTarget.skillAcquisitionTargetDetail != null ? state.skillAcquisitionTarget.skillAcquisitionTargetDetail.data.dateClosed ? moment(state.skillAcquisitionTarget.skillAcquisitionTargetDetail.data.dateClosed) : '' : '',
    isActive: state.skillAcquisitionTarget.skillAcquisitionTargetDetail != null ? state.skillAcquisitionTarget.skillAcquisitionTargetDetail.data.isActive ? state.skillAcquisitionTarget.skillAcquisitionTargetDetail.data.isActive : 0 : 0,
    targetTypeName: state.skillAcquisitionTarget.skillAcquisitionTargetDetail != null ? state.skillAcquisitionTarget.skillAcquisitionTargetDetail.data.targetType ? state.skillAcquisitionTarget.skillAcquisitionTargetDetail.data.targetType : '' : '',
    dateMetBaseline: state.skillAcquisitionTarget.skillAcquisitionTargetDetail != null ? state.skillAcquisitionTarget.skillAcquisitionTargetDetail.data.dateMetBaseline ? moment(state.skillAcquisitionTarget.skillAcquisitionTargetDetail.data.dateMetBaseline) : '' : '',
  }
}

export default connect(mapStateToProps, { getSkillAcquisitionTargetListDetails, checkFieldExistence, clearFieldErrorArray, saveTarget })(TargetModal);



// WEBPACK FOOTER //
// ./src/modules/patients/components/DataCollection/SkillAquisition/components/Target/skillAquisition_target_Modal.js